// =============================================================================
// IMAGE URL UTILITIES
// =============================================================================

/**
 * Constructs proper image URL from path
 * Handles both absolute URLs and relative paths
 * @param {string} imagePath - The image path from API response
 * @returns {string} - Properly formatted image URL
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  
  // If imagePath is already a complete URL (from CDN/media server), use it as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // If it's a relative path, ensure it starts with /
  return imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
};

/**
 * Constructs thumbnail URL with fallback
 * @param {string} thumbPath - The thumbnail path from API response
 * @param {string} fallbackPath - Fallback image path if thumb fails
 * @returns {string} - Properly formatted thumbnail URL
 */
export const getThumbnailUrl = (thumbPath, fallbackPath = '') => {
  return getImageUrl(thumbPath) || getImageUrl(fallbackPath);
};

/**
 * Constructs flag image URL for country codes
 * @param {string} countryCode - ISO country code (e.g., 'us', 'iq', 'ca')
 * @returns {string} - Flag image URL
 */
export const getFlagUrl = (countryCode) => {
  if (!countryCode) return '';
  return `/flags/${countryCode.toLowerCase()}.webp`;
};

/**
 * Handles image loading errors by providing fallback
 * @param {Event} event - Image error event
 * @param {string} fallbackSrc - Fallback image source
 */
export const handleImageError = (event, fallbackSrc = '') => {
  if (fallbackSrc) {
    if (event.target.src !== fallbackSrc) {
      event.target.src = fallbackSrc;
    }
  } else {
    // Hide the broken image instead of showing any placeholder
    event.target.style.display = 'none';
  }
};
